import { enUS } from './en-US';
import { esES } from './es-ES';
import { ptBR } from './pt-BR';

export const modalLogoutTranslate = {
  ptBR,
  enUS,
  esES,
};
